import { Spinner } from '@change/ds-core-ui';

import { stripHtmlTags } from '@change-corgi/core/html';
import { useKnownAvailableParams } from '@change-corgi/core/react/router';

import { withPrefetchedData } from 'src/shared/prefetch';

import { MovementV2PageContextProvider, prefetchPageContext } from 'src/app/pages/movementV2/pageContext';
import type { MovementV2PagePrefetchedDataProps } from 'src/app/pages/movementV2/pageContext';
import { isLoaded } from 'src/app/shared/utils/async';

import { Layout } from '../layout';

import { MovementV2ErrorHandler } from './ErrorHandler';

export const MovementV2 = withPrefetchedData(
	function MovementV2({ prefetchedData }: MovementV2PagePrefetchedDataProps) {
		const { movementId } = useKnownAvailableParams<{ movementId: string }>();

		return (
			<MovementV2PageContextProvider
				slug={movementId}
				prefetchedData={prefetchedData}
				errorHandler={MovementV2ErrorHandler}
				loadingFallback={<Spinner className="mx-auto my-64" />}
			>
				<Layout />
			</MovementV2PageContextProvider>
		);
	},
	{
		prefetchName: __MODULE_HASH__,
		// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
		prefetchData: async (context) => prefetchPageContext(context.params.movementId!, context),
		pageTitle: ({ prefetchedData }) => {
			if (!isLoaded(prefetchedData.pageData)) {
				return undefined;
			}
			return `${prefetchedData.pageData.pageData.movement.objective} · Movement`;
		},
		pageMetadata: ({ prefetchedData }) => {
			if (!isLoaded(prefetchedData.pageData)) {
				return {};
			}
			return {
				description: stripHtmlTags(prefetchedData.pageData.pageData.movement.description),
			};
		},
	},
);
